import * as Actions from '../actions'
import * as Validation from '../validation'

Actions.withOperationName(Actions)

export default [
  Actions.loadAppointmentValidationData,
  Validation.throwOnInvalidAttendees,
  Validation.throwOnInvalidRecurrence,
  Actions.loadAppointmentLoftData,
  Actions.updateProgress('connecting_salesloft'),
  Actions.getEventData,
  Actions.calendarLoft,
  Actions.stopProgress,
  Actions.loftSuccess,
  Actions.appointmentClose,
]
